// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"160":"52eb13d3","172":"aae35743"}[chunkId] + ".chunk.css";
};